import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export function ChatSuggestions({ suggestions, onPick }) {
  return (
    <div className="space-y-2 pt-2">
      <div className="text-[11px] uppercase tracking-wider text-neutral-500 mb-2">
        Suggestions
      </div>
      {suggestions.map((s) => (
        <button
          key={s}
          type="button"
          onClick={() => onPick(s)}
          data-testid={`chat-suggestion-${s.substring(0, 15).replace(/\s+/g, "-")}`}
          className="block w-full text-left text-sm bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 rounded-xl px-3 py-2.5 text-neutral-200 transition-all"
        >
          {s}
        </button>
      ))}
    </div>
  );
}

export function QualifiedCta({ onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="chat-qualified-cta"
      className="mt-3 rounded-2xl border border-[#FF5A00]/40 bg-[#FF5A00]/10 p-4"
    >
      <div className="text-sm text-white mb-3">
        🎁 <strong>Recevez une estimation personnalisée gratuite</strong> en
        moins de 24h par un expert GMC.
      </div>
      <div className="flex gap-2">
        <a
          href="tel:+33763433867"
          className="flex-1 btn-primary text-xs justify-center py-2"
          data-testid="chat-cta-call"
        >
          <Phone size={12} /> Appeler
        </a>
        <a
          href="#contact"
          onClick={onClose}
          className="flex-1 btn-ghost text-xs justify-center py-2"
          data-testid="chat-cta-contact"
        >
          Formulaire
        </a>
      </div>
    </motion.div>
  );
}
